import { css } from '@emotion/core';
import React from 'react';
import NvUserAvatar from 'components/nv-user-avatar';
import moment from 'moment';
import t from 'react-translate';
import { AngularServicesContext } from 'react-app';
import { useSelector } from 'react-redux';
import { SkillRating } from 'redux/schemas/app/video-practice';
import NvStarRating from 'shared/components/nv-star-rating';
import ResponsivelyEmbeddedAngularHTML from 'shared/components/responsively-embedded-angular-html';
import { getSkillTag } from 'redux/selectors/video-practice';
import ClickableContainer from 'components/clickable-container';
import NvIcon from 'shared/components/nv-icon';

type ViewFeedbackProps = {
  ratingId: number
  isAuthor?: boolean
  onDeleteFeedback?: (id: number) => void
  canDelete?: boolean
};
const styles = css`
  .delete-feedback {
    opacity: 0;
  }
  &:hover, &:focus-within {
    .delete-feedback {
      opacity: 1;
    }
  }
`;

const ViewFeedback = ({
  ratingId,
  isAuthor = false,
  onDeleteFeedback,
  canDelete,
}: ViewFeedbackProps) => {
  const skillRating = useSelector(state => state.models.skillRatings[ratingId]);
  const skillTag = useSelector(state => getSkillTag(state, skillRating?.skillTaggingId));
  const currentUserId = useSelector(state => state.app.currentUserId);

  const angularServices = React.useContext(AngularServicesContext);

  return (
    skillRating ? (
      <div className='d-flex mb-2' css={styles}>
        {!isAuthor && skillRating?.user && (
          <NvUserAvatar
            borderType='round'
            size='md'
            user={skillRating.user}
            displayName
            className='mx-4 mb-1 gray-2 text-small'
            directToOrgLevelProfile
            displayRoleBadge
          />
        )}
        <div className='d-flex flex-column w-100 ml-2'>
          <div className='d-flex justify-content-between mb-2'>
            <div className='d-flex'>
              <div className='text-medium font-weight-bolder gray-2 mr-2'>{skillTag?.name}</div>
              <NvStarRating readonly ratedValue={skillRating?.rating} starSize='smallest' />
            </div>
            {!isAuthor && (
            <div className='text-date gray-2'>{moment(skillRating?.createdAt).format('lll')}</div>
            )}
          </div>
          <ResponsivelyEmbeddedAngularHTML
            className='text-body'
            angularServices={angularServices}
            template={skillRating?.body}
          />
          {onDeleteFeedback && (canDelete || (currentUserId === skillRating?.user?.id)) && (
            <ClickableContainer
              className='delete-feedback d-flex gray-3 align-items-center'
              onClick={() => onDeleteFeedback(skillRating?.user?.id)}
            >
              <NvIcon icon='trash' size='xss-smallest' className='mr-1' />
              {t.NOVOED.DELETE()}
            </ClickableContainer>
          )}
        </div>
      </div>
    ) : <div />
  );
};

export default ViewFeedback;
